import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient"
import { PaginationResponse, ResponseData } from "./types/_public";
import { IFacility } from "./types/_facility";

const api = new APIClient();

const path = '/bars/work-shifts';

const timeWorkingApi = {
  getTimeWorking(params: any): Promise<AxiosResponse<ResponseData<IFacility[]> & PaginationResponse, any>> {
    const url = `${path}`
    return api.get(url, params)
  },

  getTimeWorkingDetail(id: string | number, params: any = {}) : Promise<AxiosResponse<ResponseData<IFacility>, any>>  {
    const url = `${path}/${id}`;
    return api.get(url, params)
  },
  
  deleteTimeWorking(id: any) {
    return api.delete(`${path}/${id}`);
  },
  
  postTimeWorking(dataForm: any) : Promise<AxiosResponse<ResponseData<IFacility>, any>>  {
    const url = `${path}`;
    return api.post(url, dataForm)
  },

  putTimeWorking(dataForm: any) : Promise<AxiosResponse<ResponseData<IFacility>, any>>  {
    const url = `${path}`;
    return api.put(url, dataForm)
  },
  
}

export default timeWorkingApi
